import { securedAxiosAPI } from 'utils/axios';

const securedRoute = {
    coordinateDevices: 'coordinate/devices',
    coordinatePackets: 'coordinate/packets?device_id=##DEVICE_ID##'
};

export const getCoordinateDevices = async () => {
    const res = await securedAxiosAPI.get(securedRoute.coordinateDevices);
    return res.data;
};

export const getCoordinateDeviceDetails = async (deviceId) => {
    const response = await getCoordinateDevices();
    return response?.devices?.find((device) => device.id === deviceId) || null;
};

export const getCoordinatePackets = async (deviceId) => {
    const res = await securedAxiosAPI.get(securedRoute.coordinatePackets.replaceAll('##DEVICE_ID##', deviceId));
    return res.data;
};
